<template>
  <div class="home">
    <TheHeader />
    <main>
      <HeroSection />
      <ShowcaseSection />
      <ProductSection />
      <ThreeWaysSection />

      <FeatureSection />
      <PricingSection />
      <FaqSection />
    </main>
    <TheFooter />
  </div>
</template>

<script>
import HeroSection from "@/components/section/HeroSection.vue";
import ShowcaseSection from "@/components/section/ShowcaseSection.vue";
import ProductSection from "@/components/section/ProductSection.vue";
 import ThreeWaysSection from "@/components/section/ThreeWaysSection.vue";
import FeatureSection from "@/components/section/FeatureSection.vue";
import PricingSection from "@/components/section/PricingSection.vue";
import FaqSection from "@/components/section/FaqSection.vue";
import TheHeader from "@/components/layout/Header.vue";
import TheFooter from "@/components/layout/Footer.vue";

export default {
  name: "HomeView",
  components: {
    TheHeader,
    TheFooter,
    HeroSection,
    ShowcaseSection,
    ProductSection,
    ThreeWaysSection,
    FeatureSection,
    PricingSection,
    FaqSection,
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';
</style>